// Vendor
window.$ = window.jQuery = require('jquery');
window.moment = require('moment');
window.Popper = require('popper.js');
window.Swal = require('sweetalert2');

require('bootstrap');
require('slick-carousel');

// Core
require('./utilities');
require('./main/base');
